<template>
  <div>
    <common-table :limitHeight="true" @showAccountAuthorize="showAccountAuthorize = true" :table-columns="tableColumns"
      :url="url" :operate="operate" :form-fields="formFields" :permission="permission" :searchs="searchs"
      pageName="OceanEngineAccount" ref="table"></common-table>
    <div class="mask  flex-center" v-if="showAccountAuthorize">
      <div class="popup_box">
        <div class="flex-end">
          <i class="el-icon-close cp" @click="showAccountAuthorize = false"></i>
        </div>
        <div class="text-center fs20 font-bold">
          授权方式
        </div>
        <div class="pb20">
          请选择授权方式
        </div>
        <div class="flex-between alcenter">
          <div class="authorizeBox mr10" :class="{ 'activeAuthorizeBox': !activeAuthorizeBox }"
            @click="activeAuthorizeBox = 0">
            自助授权
            <div>
              此方式直接弹出千川授权页面完成授权，适用于抖店店铺管理员自主授权
            </div>
          </div>
          <div class="authorizeBox" :class="{ 'activeAuthorizeBox': activeAuthorizeBox }"
            @click="activeAuthorizeBox = 1">
            分享链接授权
            <div>
              点击复制链接后，可分享他人在外部浏览器打开千川授权，授权完毕后刷新页面会自动同步，适用于店铺主远程授权代运营
            </div>
          </div>
        </div>
        <div v-if="!activeAuthorizeBox">
          <div class="text-center fs20 font-bold mt20 mb20">
            【敏感物料】授权
          </div>
          <div>
            授权<span class="c_primary">【敏感物料】</span> 后可以管理远程素材，否则无法预览视频或图片信息。
          </div>
          <div>
            如需预览，请按照下图操作指引进行重新授权。
          </div>
          <div class="mb20">
            成功授权后，官方生效预计需要5-10分钟，请稍后刷新页面再进行预览查看。
          </div>
          <div class="flex-center">
            <img class="instanceDiagram" src="https://qc.uliangtech.com/dist/static/image/assetsTips.1e68a19a.png"
              alt="">
          </div>
          <div class="flex-center pt50">
            <el-button type="primary" round @click="showAccountAuthorize = false">确定</el-button>
          </div>
        </div>
        <div class="c_ffb563 pt10" v-else>
          <i class="el-icon-warning"></i>
          授权链接有效期为15分钟

          <div class="flex-center pt50">
            <el-button type="primary" round @click="showAccountAuthorize = false">复制链接</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import message from "@/utils/message";
import request from "@/utils/axios";

export default {
  name: 'OceanEngineAccount',
  components: { CommonTable },
  data() {
    return {
      showAccountAuthorize: false,
      activeAuthorizeBox: 0,

      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'advertiserId',
        placeholder: '广告主',
        type: 'select',
        selectUrl: '/oceanEngineAdvertiser/optionsByCondition',
        valueKey: 'advertiserId',
        selectData: [],
      }, {
        name: 'phone',
        placeholder: '手机号',
        type: 'input'
      }, {
        name: 'status',
        placeholder: '授权状态',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '重新授权',
        }, {
          key: 2,
          value: '授权失效',
        }, {
          key: 3,
          value: '授权成功',
        }, {
          key: 4,
          value: '等待授权',
        }]
      }, {
        name: 'awemeId',
        placeholder: '抖音号UID',
        type: 'input'
      }, {
        name: 'douYinName',
        placeholder: '抖音号名称',
        type: 'input'
      }],
      permission: {
        add: 'oceanEngineAccount:add',
        update: 'oceanEngineAccount:update',
        delete: 'oceanEngineAccount:delete',
        deleteBatch: 'oceanEngineAccount:deleteBatch'
      },
      url: {
        get: '/oceanEngineAccount/listByCondition',
        add: '/oceanEngineAccount/add',
        // update: '/oceanEngineAccount/update',
        delete: '/oceanEngineAccount/delete',
        delete_batch: '/oceanEngineAccount/deleteBatch',
        status: '/oceanEngineAccount/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
      }, {
        field: 'phone',
        label: '用户',
        show: true,
        detail: true,
      }, {
        field: 'advertiserId',  // 字段名
        label: '广告主ID',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'advertiserName',  // 字段名
        label: '广告主名称',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'aweMeId',  // 字段名
        label: '抖音UID',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'awemeShowId',  // 字段名
        label: '抖音ID',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'douYinName',  // 字段名
        label: '抖音昵称',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'awemeAvatar',  // 字段名
        label: '抖音号头像',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
        img: true,
      }, {
        field: 'code',  // 字段名
        label: '达人合作码',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'authType',  // 字段名
        label: '授权类型',  // 字段显示名称
        sort: false,  // 是否排序
        show: {
          type: 'select',
        },
        selectData: [{
          id: 1,
          name: '合作达人'
        }, {
          id: 2,
          name: '自运营'
        }],
      }, {
        field: 'eventTime',  // 字段名
        label: '授权结束时间',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'status',  // 字段名
        label: '授权状态',  // 字段显示名称
        sort: false,  // 是否排序
        show: {
          type: 'select',
        },
        selectData: [{
          id: 4,
          name: '等待授权'
        }, {
          id: 2,
          name: '授权失效'
        }, {
          id: 3,
          name: '授权成功'
        }, {
          id: 1,
          name: '重新授权'
        }, {
          id: 0,
          name: '授权失败'
        }],
      },
      {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{ required: true, message: '请选择代理', trigger: 'blur' }],
            selectUrl: '/agent/getAll',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          }, {
            field: 'userId',  // 字段名
            label: '手机号',  // 字段显示名称
            type: 'select',
            placeholder: '请选择手机号',
            rules: [{ required: true, message: '请选择手机号', trigger: 'blur' }],
            selectUrl: '/userInfo/getAllInfo',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          }, {
            field: 'advertiserId',  // 字段名
            label: '广告主ID',  // 字段显示名称
            type: 'select',
            placeholder: '请输入广告主ID',
            rules: [
              { required: true, message: '广告主ID不能为空', trigger: 'blur' }
            ],
        selectUrl: '/oceanEngineAdvertiser/optionsByCondition',
            valueKey: 'advertiserId',
            selectData: [],
            add: true,
            update: false,
          }, {
            field: 'info',  // 字段名
            label: '授权信息',  // 字段显示名称
            type: 'textarea',
            placeholder: '请输入授权信息',
            rules: [
              { required: true, message: '授权信息不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'douYinName',  // 字段名
            label: '抖音昵称',  // 字段显示名称
            type: 'input',
            placeholder: '请输入抖音昵称',
            rules: [],
            add: false,
            update: false,
          }, {
            field: 'code',  // 字段名
            label: '达人合作码',  // 字段显示名称
            type: 'input',
            placeholder: '请输入达人合作码',
            rules: [
              { required: true, message: '达人合作码不能为空', trigger: 'blur' }
            ],
            add: false,
            update: false,
          }, {
            field: 'authType',  // 字段名
            label: '授权类型',  // 字段显示名称
            type: 'select',
            selectData: [{
              id: 1,
              name: '合作达人'
            }, {
              id: 2,
              name: '自运营'
            }],
            placeholder: '请选择授权类型',
            rules: [
              { required: true, message: 'authType不能为空', trigger: 'blur' }
            ],
            add: false,
            update: false,
          }, {
            field: 'eventTime',  // 字段名
            label: '授权结束时间',  // 字段显示名称
            type: 'input',
            placeholder: '请输入授权结束时间',
            rules: [
              { required: true, message: '授权结束时间不能为空', trigger: 'blur' }
            ],
            add: false,
            update: false,
          }, {
            field: 'status',  // 字段名
            label: '授权状态',  // 字段显示名称
            type: 'select',
            selectData: [{
              id: 1,
              name: '等待授权'
            }, {
              id: 2,
              name: '授权失效'
            }, {
              id: 3,
              name: '授权成功'
            }],
            placeholder: '请选择授权状态',
            rules: [
              { required: true, message: '授权状态不能为空', trigger: 'blur' }
            ],
            add: false,
            update: true,
          },
        ]
      },
      operate: [{
        icon: 'el-icon-magic-stick',
        type: 'text',
        text: '更新授权状态',
        handle: (row) => {
          request.get({
            url: '/oceanEngineAccount/selectStatus/' + row.id,
            success: (res) => {
              console.log(res)
              if (res.code === 0) {
                message.success("查询状态成功");
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          });
        }
      },]
    }
  }
}
</script>

<style scoped>
.mask {
  background-color: rgba(0, 0, 0, .5);
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;

}

.popup_box {
  font-size: 14px;
  z-index: 101;
  padding: 30px;
  background-color: rgba(252, 252, 252, 1);
  box-shadow: 0 0 10px #c7c6c6;
}

.authorizeBox {
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 350px;
  padding: 16px;
  height: 150px;
  box-sizing: border-box;
  transition: all .2s;
  display: inline-block;
}

.authorizeBox:hover {
  border-color: #346bf6 !important;
  color: #346bf6 !important
}

.activeAuthorizeBox {
  background: #4489f91a;
  border-color: #346bf6;
  color: #346bf6 !important
}

.instanceDiagram {
  width: 700px;
  box-shadow: 0 0 8px #00000029;
}


@media (max-width: 768px) {
  .popup_box {
    width: 330px;
    max-height: 80vh;
    overflow: scroll;
  }

  .instanceDiagram {
    width: 300px;
    box-shadow: 0 0 8px #00000029;
  }



  .authorizeBox {
    width: 160px;
    height: 200px;
  }

}
</style>
